export default "__VITE_ASSET__CpwUM2W5__"